import React, { useState } from 'react';
import { useTheme, IconButton, makeStyles } from '@material-ui/core';
import ContactSupport from '@material-ui/icons/ContactSupport';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const textDecoration = {
  textDecoration: 'none',
  color: 'inherit'
};

const useStyles = makeStyles(theme => ({
  noDecoration: {
    textDecoration,
    '&:focus': textDecoration,
    '&:hover': textDecoration,
    '&:visited': textDecoration,
    '&:link': textDecoration,
    '&:active': textDecoration
  },
  backgroundColor: theme.palette.background.default
}));

const Support = (props) => {
  const classes = useStyles();
  const [color, setColor] = useState(classes.backgroundColor);
  const { t } = useTranslation();
  const { user } = props;
  const group = user.signInUserSession.idToken.payload.group;
  const username = user.username;
  const enviroment = process.env.REACT_APP_ENV;
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL;
  const supportAgentEmail = process.env.REACT_APP_SUPPORT_AGENT_EMAIL;
  const theme = useTheme();

  const handleClick = (event) => {
    const mailTo = `mailto:${supportAgentEmail}` +
      `?subject=[SUPPORT ${enviroment}] ` +
      `${t('support:subject')}` +
      ` (App: ${group} - Username: ${username})` +
      `&cc=${supportEmail}` +
      `&body=${t('support:body')}`;
    window.open(mailTo, '_blank');
  };

  return (
    <div>
      <IconButton
        aria-controls='simple-menu'
        id='support-button'
        aria-haspopup='true'
        onClick={handleClick}
        color='primary'
        onMouseEnter={() => setColor('white')}
        onMouseLeave={() => setColor(theme.palette.primary.main)}>
        <ContactSupport fontSize='large' color='primary' style={{ color: `${color}` }} />
      </IconButton>
    </div>
  );
};

export default withRouter(Support);
